<template>
  <aside class="menu menu--sidebar is-collapsed">
    <ul class="menu-list">
      <li v-if="matched('diet-schedules')">
        <router-link
           tag="a" activeClass="is-active"
          :to="{ name: 'options-add-schedule-to-diet', params: { dayID } }">
          <nuttrema-iconica-sidebar-link
             icon="far fa-plus" theme="add-button"
            :title="$t('label.add_new_schedule')">
          </nuttrema-iconica-sidebar-link>
        </router-link>
      </li>
      <li v-if="matched('participant-assigned-programs')">
        <router-link
           tag="a" activeClass="is-active"
          :title="$t('label.assign_program')"
          :to="{ name: 'participant-search-programs' }">
          <nuttrema-iconica-sidebar-link icon="far fa-plus" theme="add-button"></nuttrema-iconica-sidebar-link>
        </router-link>
      </li>

<!--       <li class="hide-on-expanded">
        <sidebar-icon-level-zero></sidebar-icon-level-zero>
      </li>
      <li class="hide-on-expanded">
        <router-link
           tag="a"
          :title="$t('label.index_list')"
          :to="{ name: 'diets-list' }">
          <nuttrema-iconica-sidebar-link icon="far fa-angle-left" theme="gray"></nuttrema-iconica-sidebar-link>
        </router-link>
      </li> -->

    </ul>
  </aside>
</template>

<script>
import { find } from 'lodash';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';
import SidebarIconLevelZero from 'components/ui/menu/level-zero/sidebar-icon-level-zero';

export default {
  name: 'cmpt-menu-collapsed-top-diet-details',
  props: {
    dayID: {
      default: null,
    },
  },
  components: {
    SidebarIconLevelZero,
    NuttremaIconicaSidebarLink,
  },
  methods: {
    matched(name) {
      return find(this.$route.matched, { name });
    },
  },
  created() {
    console.log('nuttrema-iconica-sidebar-link created', this.$route);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/diets/details/shared/cmpt-menu-collapsed-top-diet-details.vue